<template>
  <BaseAccordion>
    <template #header>
      <template v-if="renderHeaderText">
        {{ header }}
      </template>
      <slot name="accordionHeader" />
    </template>

    <template #body>
      <v-list-item
        v-for="item in items"
        :key="item.attributes.title"
        :href="item.url"
        :to="item.to"
        :ripple="!isLinkTile(item)"
        link
      >
        <v-list-item-content @click="$emit('item-click')">
          <v-list-item-title>
            <LinkTile
              v-if="isLinkTile(item)"
              v-bind="item"
              render-type="navigationMobileLink"
              @click="$emit('item-click')"
            />
            <NavigationElement v-else v-bind="item" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </BaseAccordion>
</template>

<script>
import NavigationElement from '@/js/components/Navigation/NavigationElement.vue'
import NAV_CONSTANTS from '@/js/components/Navigation/utils/navigation-constants.js'

import LinkTile from '@/js/components/Shared/LinkTile.vue'

export default {
  components: {
    NavigationElement,
    LinkTile,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    renderHeaderText: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isLinkTile(item) {
      return item.type === NAV_CONSTANTS.LINK_TILE_ITEM_TYPE
    },
  },
}
</script>

<style lang="scss" module>
.navi-icon {
  :global(.v-list-item__content) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      flex: 1 1;
      width: auto;
      padding: 12px 0;
    }
    flex: unset !important;
    width: 100%;
    padding: 0 !important;
  }
}
</style>
